/* eslint react/display-name: "off" */
/* eslint react/prop-types: "off" */
import React from "react";

import { EditButton, RemoveButton } from "srx-shared/mui";

import { AdminUserItem } from "@items/AdminUser";

export const Actions = ({ row }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      width: "100%",
      margin: "3px 0"
    }}
  >
    <EditButton row={row} item={AdminUserItem} tip="Admin User" />
    <RemoveButton
      row={row}
      item={AdminUserItem}
      tip="Admin User"
      modalProps={{ size: "sm" }}
    >
      Are you sure you want to delete user:
      <br />
      <pre>
        <b>{row.email}</b>
      </pre>
    </RemoveButton>
  </div>
);
